module.exports = __webpack_public_path__ + "img/blueEdit1.a5eb24d0.svg";